export default __webpack_public_path__ + "static/media/pauline.e9a9a2ec.jpg";